import {
  TEXTOS_SUCCESS,
  TEXTOS_LOADING,
  TEXTOS_ERROR,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";

export const wsGetTextos = () => (dispatch) => {
  dispatch({
    type: TEXTOS_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get("/shared/textos")
      .then((res) => {
        dispatch({
          type: TEXTOS_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: TEXTOS_ERROR,
          payload: error,
        });
      });
  });
};
// export const wsGetTextos = () => (dispatch) => {
//   dispatch({
//     type: TEXTOS_LOADING,
//   });

//   axiosInstance().then((respuesta) => {
//     respuesta
//       .get("/texto/GetAll")
//       .then((res) => {
//         dispatch({
//           type: TEXTOS_SUCCESS,
//           payload: res.data,
//         });
//       })
//       .catch((err) => {
//         let error = {
//           detail: err.response
//             ? err.response.data
//             : "Error al contactar el server.",
//         };

//         dispatch({
//           type: TEXTOS_ERROR,
//           payload: error,
//         });
//       });
//   });
// };
